import React, { Component } from "react";
import { bindActionCreators } from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
// import styled from "styled-components";
import Store from "store";
import { fetchTagArticles } from "store/posts/actions";
// import { Link } from "routes";
import NProgress from "components/NProgress";
// import Header from '../container/DefaultLayout/header';
// import Icon from '@material-ui/core/Icon';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import NewsItem from "/components/News/NewsItem";
import { DFPSlotsProvider, AdSlot, DFPManager } from 'react-dfp';
import { Router } from "routes";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Axios from "/plugins/axios";
// import Footer from "/container/DefaultLayout/footer.js";
// import Headroom from "react-headroom";
// import BrandsSlider from '/components/brandsSlider';
// import TagManager from 'react-gtm-module'
import Hidden from '@material-ui/core/Hidden';
import MobileNewsItem from "/components/Mobile/MobileNewsItem";
import DesktopNewsItem from "/components/Desktop/DesktopNewsItem";
import ThereIsNoArticle from "/components/thereIsNoArticle";
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import getAdSlotByDevicePosition from "../utils/ads";
import ContentTitle from "/components/contentTitle";
import SeoMeta from '/components/seoMeta';

// const tagManagerArgs = {
//   dataLayer: {}
// }

const styles = theme => ({
  root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      // backgroundColor: theme.palette.background.paper,
  },
  img: {
      width: '100%',
      height: 250,
      objectFit: 'cover'
  },
  titleBar: {
      backgroundColor: 'transparent'
  },
  title: {
      backgroundColor: '#212121',
      padding: '4px 8px'
  },

  gridList: {
     height: 'auto'
  },
  divider: {
      width: '90%',
      height: 1.5,
      marginTop: 35,
      top: '20',
      border: 'none',
      backgroundColor: '#c1bcbc!important'
  },
  icon: {
      color: 'white',
  },
  button: {
      margin: '13px 0px 23px',
      paddingLeft: 25,
      letterSpacing: '1px'
  },
  layout: {
    marginLeft: 'auto',
      marginRight: 'auto',
      [theme.breakpoints.up('md')]: {
        width: 1000,
      },
      [theme.breakpoints.only('md')]: {
        width: 900,
      },
      [theme.breakpoints.only('sm')]: {
        width: 650
    },
  },
 
});

class TagArticles extends Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      newsItems: [],
      count: 1,
      next: this.props.links.next,
      url: this.props.url,
      ssrDone: false,
      adMobileTop:{
            id: 'div-gpt-ad-top-0',
            networkId: null,
            adUnit: null,
            adSizes: [[300, 250]],
            mobile: true,
            position: 'TOP',
            targetingArguments: null,
        },
      adMobileMiddle:{
            id: 'div-gpt-ad-middle-0',
            networkId: null,
            adUnit: null,
            adSizes: [[300, 250]],
            mobile: true,
            position: 'MIDDLE',
            targetingArguments: null,
        },
      adMobileBottom:{
            id: 'div-gpt-ad-bottom-0',
            networkId: null,
            adUnit: null,
            adSizes: [[300, 250]],
            mobile: true,
            position: 'BOTTOM',
            targetingArguments: null,
        },
      adMobileBottomRotate:{
            id: 'div-gpt-ad-bottom-1',
            networkId: null,
            adUnit: null,
            adSizes: [[300, 250]],
            mobile: true,
            position: 'ROTATE',
            targetingArguments: null,
        },
      adDesktopTop:{
            id: 'div-gpt-ad-desktop-global',
            networkId: null,
            adUnit: null,
            adSizes: [[970, 250]],
            mobile: false,
            position: 'TOP',
            targetingArguments: null,
        },
      adDesktopMiddle:{
            id: 'div-gpt-ad-desktop-middle',
            networkId: null,
            adUnit: null,
            adSizes: [[970, 250]],
            mobile: false,
            position: 'MIDDLE',
            targetingArguments: null,
        },
      adDesktopBottom:{
            id: 'div-gpt-ad-desktop-bottom-0',
            networkId: null,
            adUnit: null,
            adSizes: [[970, 250]],
            mobile: false,
            position: 'BOTTOM',
            targetingArguments: null,
        },
      adDesktopBottomRotate:{
            id: 'div-gpt-ad-desktop-bottom-1',
            networkId: null,
            adUnit: null,
            adSizes: [[970, 250]],
            mobile: false,
            position: 'ROTATE',
            targetingArguments: null,
        }
    };
  }  

  static getInitialProps({ query, asPath, store }) {
    const { tagArticles } = query;
    const currentDateTime = new Date().toISOString();
    store.dispatch(fetchTagArticles(tagArticles, currentDateTime));
    return { tagArticles, asPath, currentDateTime };
  }

nextPage = (url) => {
    const nextPerPage = isMobile ? 6 : 8
    url = `/articles/tags/${this.props.url.query.tagArticles}?exclude=body&published_date=${this.props.currentDateTime}&perPage=${nextPerPage}&${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
    this.setState({ 
        loading: true
     });
    Axios.get(url)
        .then(res => {
            res.data.data.map((value) => this.state.newsItems.push(value))
            this.setState({
                newsItems: this.state.newsItems,
                next: res.data.links.next,
                url: this.props.url,
                loading: false,
               })
        })
}
__nextBtn () {
    const {classes, uniReadable} = this.props;
    if(this.state.next != null) {
        return (
          <div style={{textAlign: 'center', marginTop: 10}}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => !this.state.loading ? this.nextPage(this.state.next) : null}
            >
              <span>
                {
                    uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                }
              </span>
              {this.state.loading ? 
                <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                    : 
                <div style={{display: 'inline-flex'}}>
                  <Icon>keyboard_arrow_down</Icon>
                </div> 
                 }
            </Button>
            
          </div>
        )
    }
}

__getDfpAds = (index) => {
    const { ads } = this.props;
    const adMobileBottomRotate = getAdSlotByDevicePosition(true, ads, this.state.adMobileBottomRotate.position);
    const adDesktopBottomRotate = getAdSlotByDevicePosition(false, ads, this.state.adDesktopBottomRotate.position);
    const ssrDone = this.state.ssrDone;
      <div className='ads-style'>
        <Hidden only={['md', 'lg', 'xl']}>
          {/* <MobileView> */}
          {
                    ssrDone && adMobileBottomRotate.id &&
                    <AdSlot
                      sizes={adMobileBottomRotate.adSizes}
                      dfpNetworkId={adMobileBottomRotate.networkId}
                      adUnit={adMobileBottomRotate.adUnit}
                      // targetingArguments={adMobileBottomRotate.targetingArguments}
                      shouldRefresh={()=> false}
                        // slotId={adMobileBottomRotate.id}
                    />
                    }
          {/* </MobileView> */}
        </Hidden>
        <Hidden smDown>
          {/* <BrowserView> */}
          {
                    ssrDone && adDesktopBottomRotate.id &&
                    <AdSlot
                      sizes={adDesktopBottomRotate.adSizes}
                      dfpNetworkId={adDesktopBottomRotate.networkId}
                      adUnit={adDesktopBottomRotate.adUnit}
                      shouldRefresh={()=> false}
                        // slotId={adDesktopBottomRotate.id}
                    />
                    }
          {/* </BrowserView> */}
        </Hidden>
      </div>
  }

render() {
    const { tag, links, categories, classes, ads, brands } = this.props;
    const {newsItems} =this.state;
    const adMobileTop = getAdSlotByDevicePosition(true, ads, this.state.adMobileTop.position);
    const adMobileMiddle = getAdSlotByDevicePosition(true, ads, this.state.adMobileMiddle.position);
    const adMobileBottom = getAdSlotByDevicePosition(true, ads, this.state.adMobileBottom.position);
    const adDesktopTop = getAdSlotByDevicePosition(false, ads, this.state.adDesktopTop.position);
    const adDesktopMiddle = getAdSlotByDevicePosition(false, ads, this.state.adDesktopMiddle.position);
    const adDesktopBottom = getAdSlotByDevicePosition(false, ads, this.state.adDesktopBottom.position);
    const ssrDone = this.state.ssrDone;
    const tagName = `${this.props.url.query.tagArticles}`
    return (
      <div>
        <Head>
          <title>{this.props.url.query.tagArticles}</title>
        </Head>
        <SeoMeta 
            url={`${process.env.BACKEND_URL}${this.props.asPath}`} 
            type="article"
            title={this.props.url.query.tagArticles}
            description={this.props.url.query.tagArticles}
            image='https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg'
          />        
        <NProgress />
        
        <div className='ads-global-style'>
          <Hidden only={['md', 'lg', 'xl']}>
            {/* <MobileView> */}
            <div style={{textAlign : 'center'}}>
              {
                        ssrDone && adMobileTop.id &&
                        <AdSlot
                          sizes={adMobileTop.adSizes}
                          dfpNetworkId={adMobileTop.networkId}
                          adUnit={adMobileTop.adUnit}
                          shouldRefresh={()=> false}
                          slotId={adMobileTop.id}
                        />
                    }
            </div>
          </Hidden>
          {/* </MobileView> */}
          <Hidden smDown>
            {/* <BrowserView> */}
            <div style={{textAlign : 'center'}}>
              {
                        ssrDone && adDesktopTop.id &&
                        <AdSlot
                          sizes={adDesktopTop.adSizes}
                          dfpNetworkId={adDesktopTop.networkId}
                          adUnit={adDesktopTop.adUnit}
                          // targetingArguments={adDesktopTop.targetingArguments}
                          shouldRefresh={()=> true}
                          slotId={adDesktopTop.id}
                        />
                    }
            </div>
            {/* </BrowserView> */}
          </Hidden>
        </div>
  
        {/* <div className={classes.root} style={{marginBottom: 20}}> */}
        <Hidden only={['md', 'lg', 'xl']}>
          {/* <MobileView> */}
          <div className={classes.root}>
            <div className='mobileLayout'>
              <div style={{textTransform: 'Capitalize', marginBottom: 10}}>
                <ContentTitle contentTitle={fontUniOrConvertZawgyi(tagName)} color="#000" />
              </div>
              {tag.length == 0 ? 
                <ThereIsNoArticle />  : 
                <React.Fragment>
                  {tag.length > 0 && tag.map((item, index) => (
                        index < 6 ?
                          <React.Fragment key={index}>
                            <MobileNewsItem key={index} item={item} />
                            {index === 2 ? 
                            // <MobileView>
                              <div className="ads-style">
                                {
                                    ssrDone && adMobileMiddle.id &&
                                    <AdSlot
                                      sizes={adMobileMiddle.adSizes}
                                      dfpNetworkId={adMobileMiddle.networkId}
                                      adUnit={adMobileMiddle.adUnit}
                                      // targetingArguments={adMobileMiddle.targetingArguments}
                                      shouldRefresh={()=> true}
                                      slotId={adMobileMiddle.id}
                                    />
                                }
                              </div> 
                              // {/* </MobileView> */}
                              : null}
                            {index === 5 ? 
                            //  <MobileView>
                              <div className='ads-style'>
                                {
                                  ssrDone && adMobileBottom.id &&
                                  <AdSlot
                                    sizes={adMobileBottom.adSizes}
                                    dfpNetworkId={adMobileBottom.networkId}
                                    adUnit={adMobileBottom.adUnit}
                                    // targetingArguments={adMobileBottom.targetingArguments}
                                    shouldRefresh={()=> false}
                                      // slotId={adMobileBottom.id}
                                  />
                                }
                              </div>
                              // </MobileView>
                                        : null
                                    }   
                          
                          </React.Fragment>
                        : null  ))}
                </React.Fragment> 
                  }

              {newsItems && newsItems.map((newsItem, index) => (
                  // for style use React.Fragment instead <div>
                <React.Fragment key={index} > 
                  <MobileNewsItem key={index} item={newsItem} />
                  {index > 0 && ((index+1) % 3) === 0 ? this.__getDfpAds(Math.floor(index / 3)) : null }
                </React.Fragment>
                  ))}
              { links.next ?  this.__nextBtn() : null} 

            </div>
          </div>
          {/* </MobileView> */}
        </Hidden>
        <Hidden smDown>
          {/* <BrowserView> */}
          <div className={classes.root}>
            <div className='layout'>
              
              <Grid container>
                <ContentTitle contentTitle={fontUniOrConvertZawgyi(tagName)} color="#000" />
              </Grid>
              {tag.length == 0 ? 
                <ThereIsNoArticle />  : 
                <Grid container>
                  {tag.length > 0 && tag.map((item, index) => (
                    <React.Fragment key={index}>
                      <Grid item xs={3}>
                          <DesktopNewsItem item={item}  />
                        </Grid>  
                      {index === 7 ?
                          <Grid item xs={12} key={index}> 
                              {/* <BrowserView> */}
                              <div className="ads-style">
                                {
                                      ssrDone && adDesktopMiddle.id &&
                                      <AdSlot
                                        sizes={adDesktopMiddle.adSizes}
                                        dfpNetworkId={adDesktopMiddle.networkId}
                                        adUnit={adDesktopMiddle.adUnit}
                                        // targetingArguments={adDesktopMiddle.targetingArguments}
                                        shouldRefresh={()=> false}
                                          // slotId={adDesktopMiddle.id}
                                      />
                                    }
                              </div>
                              {/* </BrowserView> */}
                            </Grid>
                                : null}
                    </React.Fragment>
                        ))}  
                </Grid>
                    }
            
           
              <Grid container>
                {newsItems && newsItems.map((item, index) => (
                  <React.Fragment key={index}>
                    <Grid item xs={3}>
                      <DesktopNewsItem item={item}  />
                    </Grid>
                    {index > 0 && ((index+1) % 8) === 0 ? <Grid item xs={12} key={index}> {this.__getDfpAds(Math.floor(index / 8))} </Grid> : null}
                  </React.Fragment>
                          ))}  
              </Grid>
              
              { links.next ?  this.__nextBtn() : null} 
            </div>
          </div>
          {/* </BrowserView> */}
               
        </Hidden>
                        
      </div>
    );
}
    componentDidMount () {
        this.setState({
            ssrDone: true,
            // next: this.props.links.next
        });
        if(isBrowser) {
          this.secondPage =  this.state.next;
          window.addEventListener('scroll', this.handleScroll.bind(this, this));
        }
    }
    componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(that, event) {
      if(window.pageYOffset > 200 && isBrowser && !this.pageTwoLoaded) {
        // console.log("window.pageYOffset > 200");
        if(that.secondPage != null) {
          that.nextPage(that.secondPage);
        }
        that.pageTwoLoaded = true;
      }
    }    
    componentDidUpdate(previousProps, previousState){
        const categorySegment = this.props.url.query.tag;
        DFPManager.setTargetingArguments({'section': categorySegment });
        DFPManager.refresh();
        DFPManager.load();
        DFPManager.setCollapseEmptyDivs( true );
        // TagManager.dataLayer(tagManagerArgs)
        
        if(previousProps.url.query.tag != this.props.url.query.tag) {
          if(isBrowser) {
            this.pageTwoLoaded = false;
          }   
        }
    }
}

TagArticles.propTypes = {
  classes: PropTypes.object.isRequired,
  tag: PropTypes.arrayOf(PropTypes.object).isRequired,
//   brands: PropTypes.arrayOf(PropTypes.object).isRequired
};

const mapStateToProps = state => ({
  tag: state.posts.tagArticles.data,
  links: state.posts.tagArticles.links,
  ads: state.posts.tagArticles.ads,
//   brands: state.posts.brands
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchTagArticles,
    //   fetchBrands
    },
    dispatch
  );

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(
  withReduxSaga(withStyles(styles)(TagArticles))
);
